<!-- 新增loading 或者点击编辑弹窗中点击编辑行之后loading, 详情页展示的时候不显示loading -->
<nz-spin [nzSpinning]="(!clickToEdit || isEditing) && loading" content>
    <app-sub-panel [title]="fieldName" [className]="className" [isRequired]="isRequired">
        <div action>
            <span nz-icon (click)="addResource()" nzType="plus" nzTheme="outline" class="add-icon" nz-tooltip nzTooltipTitle="Add Resource"></span>
        </div>
        <div content>
            <ng-container *ngIf="(!isEditing && currentValue.length === 0) || (currentValue.length === 0 && !clickToEdit); else contentTemp">
                <div class="display-area" (click)="addResource()">
                    <span class="empty-content">Add resources ...</span>
                </div>
            </ng-container>

            <ng-template #contentTemp>
                <div class="row-item" *ngFor="let row of currentValue; let i = index">
                    <div class="row-left">
                        <div *ngIf="!isEditing" (click)="startEdit()" class="click-to-edit-area">
                            {{row.resourceNames}}
                        </div>
                        <nz-input-group nzCompact *ngIf="isEditing" class="left-edit">
                            <nz-select
                                    [(ngModel)]="row.resourceInstanceGroupId"
                                    class="type-select"
                                    (ngModelChange)="changeGroup(row, i)"
                                    [nzCustomTemplate]="groupSelectedTemplate"
                                    [nzDropdownMatchSelectWidth]="false"
                            >
                                <nz-option
                                        *ngFor="let groupItem of groupOptions"
                                        [nzLabel]="groupItem.label"
                                        [nzValue]="groupItem.value"
                                        nzCustomContent
                                >
                                    {{ groupItem.label | overflowText }}
                                </nz-option>
                            </nz-select>
                            <ng-template #groupSelectedTemplate let-selected>
                                <div class="selected-item">
                                    {{ selected.nzLabel }}
                                </div>
                            </ng-template>
                            <nz-tree-select
                                #treeSelect
                                *ngIf="row.resourceInstanceGroupId === 'all'; else selectEl"
                                [nzDropdownClassName]="'resource-tree-dropdown'"
                                class="resource-select resource-tree-select"
                                [nzNodes]="row.resourceOptions"
                                [(ngModel)]="row.resources"
                                [nzCheckStrictly]="true"
                                nzShowSearch
                                nzCheckable
                                nzPlaceHolder="Please select"
                                [nzTreeTemplate]="treeTemplate"
                                [nzDropdownMatchSelectWidth]="false"
                                [nzHideUnMatched]="true"
                                (ngModelChange)="getGanttChart()"
                            >
                                <ng-template #treeTemplate let-node>
                                    <app-overflow-num-tooltip [text]="node.title" [maxLength]="40"></app-overflow-num-tooltip>
                                </ng-template>
                            </nz-tree-select>
                            <ng-template #selectEl>
                                <nz-select
                                    class="resource-select"
                                    [(ngModel)]="row.resources"
                                    nzMode="multiple"
                                    [nzDropdownMatchSelectWidth]="false"
                                    [nzCustomTemplate]="resourceSelectedTemplate"
                                    (ngModelChange)="getGanttChart()"
                                >
                                    <nz-option
                                        *ngFor="let item of row.resourceOptions"
                                        [nzLabel]="item.label"
                                        [nzValue]="item.value"
                                        nzCustomContent
                                    >
                                        {{ item.label | overflowText }}
                                    </nz-option>
                                </nz-select>
                            </ng-template>
                            <ng-template #resourceSelectedTemplate let-selected>
                                <div class="selected-item">
                                    {{ selected.nzLabel }}
                                </div>
                            </ng-template>
                        </nz-input-group>
                    </div>
                    <div class="row-right">
                        <div class="tester-times">
                            <div class="time-item" *ngFor="let item of row.timeIntervals; let j = index">
                                <ng-container *ngIf="isEditing">
                                    <nz-date-picker class="time-select" [nzPlaceHolder]="[dateDefault]"
                                                    [nzShowTime]="{ nzFormat: 'h a', nzHideSeconds: true, nzUse12Hours: true }"
                                                    nzFormat="yyyy-MM-dd h a" [(ngModel)]="item.startDate"
                                                    (ngModelChange)="getUpdatedDateRange()"></nz-date-picker>
                                    <nz-date-picker class="time-select" [nzPlaceHolder]="[dateDefault]"
                                                    [nzShowTime]="{ nzFormat: 'h a', nzHideSeconds: true, nzUse12Hours: true }"
                                                    nzFormat="yyyy-MM-dd h a" [(ngModel)]="item.endDate"
                                                    (ngModelChange)="getUpdatedDateRange()"></nz-date-picker>
                                    <div class="action">
                                        <i *ngIf="row.timeIntervals.length > 1" nz-icon nzType="minus-circle-o" class="time-icon"
                                           nz-tooltip="Remove booking time" (click)="removeTime(i, j)"></i>
                                        <i nz-icon nzType="plus-circle" class="time-icon" nz-tooltip="Add booking time"
                                           (click)="addTime(i, j)"></i>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="!isEditing">
                                    <div class="click-to-edit-area time-select" (click)="startEdit()">
                                        <span>{{ item.startDate | date: "YYYY-MM-dd h a" }}</span>
                                    </div>
                                    <div class="click-to-edit-area time-select" (click)="startEdit()">
                                        <span>{{ item.endDate | date: "YYYY-MM-dd h a" }}</span>
                                    </div>
                                </ng-container>

                            </div>
                        </div>
                        <button *ngIf="isEditing" nz-button nzDanger nz-tooltip="Unassign" class="remove-row"
                                (click)="removeRow(i)">
                            <i nz-icon nzType="delete" nzTheme="outline"></i>
                        </button>
                    </div>
                </div>
                <div *ngIf="showGantt && currentValue[0]?.resourceInstanceGroupId !== null" class="gantt-panel">
                    <ngx-gantt #gantt
                               [maxLevel]="2"
                               [async]="true"
                               [virtualScrollEnabled]="false"
                               [loadingDelay]="300"
                               [items]="items"
                               [viewType]="viewType"
                               [viewOptions]="viewOptions"
                               style="height: 500px; display: block;">
                      <ngx-gantt-table>
                          <ng-template #bar let-bar='item'>
                              <div nz-tooltip [nzTooltipTitle]="bar.title" [nzTooltipPlacement]="'topLeft'" [nzTooltipColor]="'orange'" style="color: #fff; white-space: nowrap; padding-left: 5px; overflow: hidden; text-overflow: ellipsis;">
                                  {{ bar.title }}
                              </div>
                          </ng-template>
                        <ngx-gantt-column [name]="'Resources'" [width]="200">
                          <ng-template #cell let-item="item">
                            <ng-container *ngIf="item.title != 'Load More'; else loadMoreTemplate" class="gantt-cell-content">
                              <div class="gantt-item-title" nz-tooltip [nzTooltipTitle]="item.title" [nzTooltipPlacement]="'topRight'" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                {{ item.title }}
                              </div>
                            </ng-container>
                            <ng-template #loadMoreTemplate>
                              <ng-container *ngIf="showLoadMore(item.id)">
                                <button nz-button class="load-more-btn" (click)="loadMoreChild(item.id)">Load More</button>
                              </ng-container>
                            </ng-template>
                          </ng-template>
                        </ngx-gantt-column>
                      </ngx-gantt-table>
                    </ngx-gantt>
                </div>
                <div class="action-group" *ngIf="isEditing && clickToEdit">
                    <button nz-button nzType="primary" class="action-item" (click)="handleSave()" [nzLoading]="saveLoading">Save</button>
                    <button nz-button  nzDanger class="action-item" (click)="handleCancel()">Cancel</button>
                </div>
            </ng-template>
        </div>
    </app-sub-panel>
</nz-spin>
